<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="(value | number:'1.0-0') + '°'">
  <div app-theme-option-content>
    <app-show-details-option [showDetails]="showDetails" (sendShowDetails)="receiveShowDetails($event)">
      <div app-show-details-option-content>
        <app-slider [color]="color" [value]="value" (sendValue)="receiveValue($event)" [step]="5" [max]="360"></app-slider>
      </div>
    </app-show-details-option>
  </div>
</app-theme-option>

<div *ngIf="showDetails">
  <app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categoriesAndLabel" [label]="type | chart" [dark]="4" *ngFor="let type of themeOptions.limitedTo(optionType)" [information]="(values[type] | number:'1.0-0') + '°'">
    <div app-theme-option-content>
      <app-slider [color]="color" [value]="values[type]" (sendValue)="receiveValue($event, type)" [step]="5" [max]="360"></app-slider>
    </div>
  </app-theme-option>
</div>